import { render, staticRenderFns } from "./deleteChain.vue?vue&type=template&id=c131ea72"
import script from "./deleteChain.vue?vue&type=script&lang=js"
export * from "./deleteChain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports